<template>
  <div class="detail-root">
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="918px"
      @closed="onClosed"
      v-loading="loading"
    >
      <div class="content form-content">
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>人员姓名</div>
          <div class="value input">
            <el-input
              size="small"
              maxlength="20"
              v-model.trim="formData.name"
              placeholder="请输入姓名"
            ></el-input>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>联系方式</div>
          <div class="value input">
            <el-input
              size="small"
              maxlength="20"
              v-model.trim="formData.tel"
              :disabled="action === 2"
              placeholder="请输入账号"
            ></el-input>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>身份证</div>
          <div class="value input">
            <ossFileUpload
              key="1"
              ref="refUserFileUpload"
              v-model="userFiles"
              :limit="3"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span
                >请上传业务员身份证正反面。格式要求：pdf或图片，且不超过10M，最多上传3个。</span
              >
            </div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">毕业证</div>
          <div class="value input">
            <ossFileUpload
              key="2"
              ref="refContractFileUpload"
              v-model="schoolFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span>格式要求：上传pdf或图片，且不超过10M，最多上传5个。</span>
            </div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">医师/药师资格证</div>
          <div class="value input">
            <ossFileUpload
              key="3"
              ref="refEmployeeFileUpload"
              v-model="medicalFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span>格式要求：上传pdf或图片，且不超过10M，最多上传5个。</span>
            </div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">其他</div>
          <div class="value input">
            <ossFileUpload
              key="4"
              ref="refOtherFileUpload"
              v-model="otherFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span>格式要求：上传pdf或图片，且不超过10M，最多上传5个。</span>
            </div>
          </div>
        </div>
      </div>
      <OpsCheck
        :rejectHistory="memberInfo?.auditLogList || []"
        :auditStatusPass="2"
        ref="opsCheckRef"
        :isCheck="action === 2"
      ></OpsCheck>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="handleSubmitChect"
          v-if="action === 2"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  csoResourceUserDetail,
  auditCsoResourceUser,
} from "@/api/compliance/checkSalesman";
import ossFileUpload from "@/components/ossFileUpload";
import OpsCheck from "./ops-check.vue";
// import { getOssSrcFileName } from "@/utils/oss";

export default {
  components: {
    ossFileUpload,
    OpsCheck,
  },
  data() {
    return {
      action: 1, //1 查看  2 审核
      dialogVisible: false,
      mainId: null, //
      loading: false,
      formData: {
        name: "",
        tel: "",
      }, //
      memberInfo: null,
      userFiles: [], // 身份证列表
      schoolFiles: [], // 毕业证
      medicalFiles: [], // 医药/药师资格证
      otherFiles: [], // 其他材料
      picFileExt: ".jpg,.png,.pdf,.jpeg",
    };
  },
  computed: {
    title() {
      let txt = "";
      if (this.action === 2) {
        txt = ` 审核${txt}`;
      } else if (this.action === 1) {
        txt = `查看${txt}`;
      }
      return txt;
    },
    isLook() {
      return true;
    },
  },
  methods: {
    open(options = null) {
      if (options) {
        const { action, row } = options;
        this.action = action || 1;
        if (row && row.id) {
          this.mainId = row.id;
          this.getDetail();
        }
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.refUserFileUpload.init(); //初始化oss上传
        this.$refs.refContractFileUpload.init(); //初始化oss上传
        this.$refs.refOtherFileUpload.init(); //初始化oss上传
        this.$refs.refEmployeeFileUpload.init(); //初始化oss上传
      });
    },
    handleSubmitChect() {
      const checkFormData = this.$refs.opsCheckRef.publicGetFormData();
      const obj = {
        id: this.mainId,
        auditStatus: checkFormData.auditStatus == 1 ? 2 : 3,
        refuseReason: checkFormData.refuseReason,
      };
      auditCsoResourceUser(obj).then((res) => {
        if (res) {
          this.$message.success("审核成功");
          this.close();
          this.$emit("onRefresh");
        }
      });
    },
    close() {
      this.dialogVisible = false;
    },
    onClosed() {
      this.reset();
    },
    reset() {
      this.$refs.opsCheckRef.publicResetFormData();
      this.action = 1;
      this.mainId = "";
      this.formData = {
        name: "",
        tel: "",
      };
      this.memberInfo = null;
      this.userFiles = [];
      this.schoolFiles = [];
      this.medicalFiles = [];
      this.otherFiles = [];
      this.loading = false;
    },
    getDetail() {
      if (this.mainId) {
        this.loading = true;
        // 替换新的获取详情方法
        csoResourceUserDetail(this.mainId)
          .then((data) => {
            if (data) {
              this.formData = {
                name: data.name || "",
                tel: data.tel || "",
              };
              this.memberInfo = data;
              let filesData = data.attachmentList;
              if (filesData && filesData.length > 0) {
                this.userFiles = filesData
                  .filter((li) => li.attType == 1)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.schoolFiles = filesData
                  .filter((li) => li.attType == 2)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.medicalFiles = filesData
                  .filter((li) => li.attType == 3)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.otherFiles = filesData
                  .filter((li) => li.attType == 4)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    getUploadFileUrl(item, type = 1) {
      let netUrl = "";
      if (item) {
        if (item.url) {
          //可能是已经上传过的
          netUrl = item.url;
        } else if (
          //服务器返回过来的
          item.response &&
          item.response.data &&
          item.response.data.url
        ) {
          netUrl = item.response.data.url;
        }
      }
      // attType = 1 身份证 2 毕业证 3 医药/药师资格证 4 其他材料
      return { name: item.name, url: netUrl, attType: type };
    },
    parseToUploadUrl(el) {
      const { url, name } = el;
      // attachUrl 取最后一个.后面的字符串 作为文件类型
      if (url) {
        const reg = /(\.\w+)$/;
        const type = reg.exec(url)[1];
        const paddName = type ? name + type : name;
        return { name: paddName, url: url };
      }
      return { name: name, url: "" };
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-root {
  .form-content {
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 0;
      box-sizing: border-box;
      &.mutlti {
        align-items: flex-start;
      }
      &.big {
        .tip {
          height: 32px;
          line-height: 32px;
        }
      }
      .tip {
        width: 8em;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
        text-align: right;
        color: #262626;
        span.point {
          color: #f00;
          margin-right: 2px;
        }
      }
      .value {
        margin-left: 16px;
        &-desc {
          line-height: 1;
          margin-top: 6px;
          color: #8c8c8c;
          font-size: 13px;
        }
        &.input {
          width: calc(100% - 200px);
        }
        &.fill {
          flex: 1;
          width: 0;
        }
        .small-tip {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #8c8c8c;
          &.warning {
            color: #e6a23c;
          }
        }
        &.mutlti {
          flex: 1;
          width: 0;
          display: flex;
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
    min-height: 240px;
  }
}
</style>
